import { apiClient } from './client';
import { PaginatedResponse } from '../types/pagination';
import { EmailDelivery, PortalAccountRow, PortalAccountStatus } from '../types/portalAccount';

// Student Portal login management (Phase 100) — Super Admin only.

export const listPortalAccounts = async (params: {
  page: number;
  pageSize: number;
  search?: string;
  status?: PortalAccountStatus;
}): Promise<PaginatedResponse<PortalAccountRow>> => {
  const { data } = await apiClient.get('/students/portal-accounts', { params });
  return data;
};

export const invitePortalAccount = async (
  studentId: number,
): Promise<{ invite: { status: 'SENT' | 'FAILED'; errorMessage: string | null }; account: PortalAccountRow }> => {
  const { data } = await apiClient.post(`/students/${studentId}/portal-account/invite`);
  return data.data;
};

export const sendPortalPasswordReset = async (
  studentId: number,
): Promise<{ delivery: EmailDelivery; error: string | null; expiresAt: string | null }> => {
  const { data } = await apiClient.post(`/students/${studentId}/portal-account/password-reset`);
  return data.data;
};

export const changePortalLoginEmail = async (
  studentId: number,
  email: string,
  confirmEmail: string,
): Promise<{ account: PortalAccountRow; notified: { previousAddress: EmailDelivery; newAddress: EmailDelivery } }> => {
  const { data } = await apiClient.patch(`/students/${studentId}/portal-account/email`, { email, confirmEmail });
  return data.data;
};

export const setPortalAccountEnabled = async (
  studentId: number,
  enabled: boolean,
  reason?: string,
): Promise<PortalAccountRow> => {
  const { data } = await apiClient.post(`/students/${studentId}/portal-account/${enabled ? 'enable' : 'disable'}`, {
    reason: reason || undefined,
  });
  return data.data;
};
